import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { ChromePicker } from 'react-color'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import {
    Link,
    Redirect
} from 'react-router-dom'
import ImageUploaderDropZone from "../../common/image-uploader/dropzone.component.jsx"
import SideBar from "../../common/layout/sidebar.component.jsx"
import ProposalOptionName from "../../common/proposal/optionname.component.jsx"
import ProposalColorPreview from "./colorPreview.component.jsx"
import "./option.scss"
class ProposalOptionsEditForm extends Component {

    constructor(props, context) {
        super(props, context)

        this.supportedOptions = [
            'primary-color',
            'secondary-color',
            'group-title-background-color',
            'button-color',
            'banner-color',
            'background-color',
            'background-image-id',
            'font',
            'additional-color-1',
            'additional-color-2',
            'additional-color-3',
            'print-size',
        ]
        this.supportedFonts = [
            'Karla',
            'Arial',
            'Helvetica',
            'Times New Roman',
            'Courier',
            'Lato',
            'Merriweather',
            'Nanum Gothic',
            'Noto Sans',
            'Nunito',
            'PT Serif',
            'Raleway',
            'Roboto',
            'Roboto Thin',
            'Roboto Light',
            'Verdana',
            'Varela Round',
            'Sunflower',
            'Ubuntu',
            'Montserrat',
            'Avenir Next',
            'Open Sans',
            'Work Sans',
            'EB Garamond',
        ].sort()

        this.state = {
            options: [],
            backgroundImage: null,
            backgroundImages: [],
            loaded: false,
        }
        for (let i in this.supportedOptions) {
            this.state[this.supportedOptions[i]] = ''
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submitOptions = this.submitOptions.bind(this)
        this.handleBackgroundChange = this.handleBackgroundChange.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        Promise.all(this.supportedOptions.map(optionKey =>
            AppContext.getApiClient().get('/default-proposal-options/' + optionKey)
        )).then(results => {
            let state = {
                options: results,
            }
            for (let i in results) {
                state[results[i].attributes.optionKey] = results[i].attributes.value
            }
            this.setState(state, () => {
                if (this.state["background-image-id"]) {
                    AppContext.getApiClient().get('/images/' + this.state["background-image-id"]).then(i => {
                        this.setState({
                            backgroundImage: i,
                            backgroundImages: [i],
                            loaded: true,
                        })
                    })
                } else {
                    this.setState({
                        loaded: true,
                    })
                }
            })
        })
    }

    handleBackgroundChange(images) {
        if (images.length > 0) {
            this.setState({
                ["background-image-id"]: images[0].id,
                options: this.updateOption("background-image-id", images[0].id),
                backgroundImage: images[0],
            })
        } else {
            this.setState({
                ["background-image-id"]: '',
                backgroundImage: null,
                options: this.updateOption("background-image-id", ''),
            })
        }
    }

    renderOptionInput(option) {
        let input = ''
        switch (option.attributes.type) {
            case 'boolean':
                input = <input
                    className="form-check-input"
                    type="checkbox"
                    id={option.attributes.optionKey}
                    name={option.attributes.optionKey}
                    value={this.state[option.attributes.optionKey]}
                    checked={this.state[option.attributes.optionKey]}
                    onChange={this.handleFormChange}
                />
                break
            case 'string':
            case 'integer':
                input = <input
                    id={option.attributes.optionKey}
                    name={option.attributes.optionKey}
                    value={this.state[option.attributes.optionKey]}
                    onChange={this.handleFormChange}
                    type="text"
                    className="form-control"
                />
                break
        }
        if (option.attributes.optionKey === 'primary-color' ||
            option.attributes.optionKey === 'secondary-color' ||
            option.attributes.optionKey === 'group-title-background-color' ||
            option.attributes.optionKey === 'banner-color' ||
            option.attributes.optionKey === 'button-color' ||
            option.attributes.optionKey === 'additional-color-1' ||
            option.attributes.optionKey === 'additional-color-2' ||
            option.attributes.optionKey === 'additional-color-3' ||
            option.attributes.optionKey === 'background-color') {
            input = <ChromePicker
                onChangeComplete={ this.handleColorPickerChange(option.attributes.optionKey) }
                color={ this.state[option.attributes.optionKey] }
            />
        }
        if (option.attributes.optionKey === 'background-image-id' && this.state.loaded) {
            input = <div className="row">
                <div className="col-md-12 col-lg-12">
                    <ImageUploaderDropZone
                        onUpdateImageList={this.handleBackgroundChange}
                        maxFiles={1}
                        images={this.state.backgroundImages}
                    />
                </div>
            </div>
        }
        if (option.attributes.optionKey === 'font') {
            input = <div className="row">
                <div className="col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-12">
                            <select
                                className="form-control"
                                id={option.attributes.optionKey}
                                name={option.attributes.optionKey}
                                value={this.state[option.attributes.optionKey]}
                                onChange={this.handleFormChange}>
                                {this.supportedFonts.map((f, key) => {
                                    return <option key={key} value={f} style={{ fontFamily: f }}>
                                        {f}
                                    </option>
                                })}
                            </select>
                        </div>
                        <div className="col-12 pt-2" style={{fontFamily: this.state[option.attributes.optionKey]}}>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                            sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
                            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                            Sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                        </div>
                    </div>
                </div>
            </div>
        }       
        if (option.attributes.optionKey === 'print-size') {
            input = <div className="row">
                <div className="col-12">
                  <select
                    className="form-control"
                    id={option.attributes.optionKey}
                    name={option.attributes.optionKey}
                    value={this.state[option.attributes.optionKey]}
                    onChange={this.handleFormChange}>
                    <FormattedMessage id='proposal.options.small_size_option' defaultMessage='Small'>
                        {(text) =>  <option value='Small'>{text}</option>}
                    </FormattedMessage>
                    <FormattedMessage id='proposal.options.medium_size_option' defaultMessage='Medium'>
                        {(text) =>  <option value='Medium'>{text}</option>}
                    </FormattedMessage>
                    <FormattedMessage id='proposal.options.large_size_option' defaultMessage='Large'>
                        {(text) =>  <option value='Large'>{text}</option>}
                    </FormattedMessage>
                  </select>
                </div>
                <div className="col-12 pt-2" style={{fontSize: this.state[option.attributes.optionKey]}}>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                            sed diam voluptua. 
                </div>
            </div>
          }
        return <div className="col-6" >{input}</div>
    }
    
    renderOptionLabel(option) {
        return <label className="col-6 text-align-right" htmlFor="show-taxes">
            <ProposalOptionName value={option.attributes.optionKey} />
        </label>
    }

    submitOptions(event) {
        event.preventDefault()
        Promise.all(this.supportedOptions.map(optionKey =>
            AppContext.getApiClient().patch('/default-proposal-options/' + optionKey, {
                value: this.state[optionKey]
            })
        )).then(responses => {
            let hasError = false
            for (let i in responses) {
                if (responses[i].error) {
                    hasError = true
                }
            }
            if (!hasError) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/branding' }} /> })
            }
        })
    }

    updateOption(key, value) {
        return this.state.options.map(o => {
            if (o.attributes.optionKey === key) {
                o.attributes.value = value
            }
            return o
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            options: this.updateOption(name, value)
        });
    }

    handleColorPickerChange(optionKey) {
        return function(color) {
            this.setState({
                [optionKey]: color.hex,
                options: this.updateOption(optionKey, color.hex)
            })
        }.bind(this)
    }

    render() {
        const messages = defineMessages({
            "save_btn": {
                id: 'proposal.options.form.edit.save_btn',
                defaultMessage: 'Save',
            }
        })
        return (
            <form onSubmit={this.submitOptions}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className={"row"}>
                            <div className={"col-md-6"}>
                                {this.state.options.map(option => {
                                        return <div className="row form-group" key={option.id}>
                                            {this.renderOptionLabel(option)} {this.renderOptionInput(option)}
                                        </div>
                                    }
                                )}
                            </div>
                            <div className={"col-md-6 pr-5 sticky-top"} >
                                <ProposalColorPreview className={"sticky-top"} style={{top: '70px'}} options={this.state.options} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6 text-align-right">
                                <Link to="/branding" className="btn btn-light">
                                    <FormattedMessage
                                        id="proposal.options.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(ProposalOptionsEditForm)


// WEBPACK FOOTER //
// ./src/settings/proposals/optionsEditForm.component.jsx